import { useFocusEffect, useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import {
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { globalFontStyle, globalStyle } from "../../../assets";
import CommonModal from "../../../commonComponents/commonModal";
import { getContestCoinsBalance } from "../redux/contest.action";
import HowToContest from "./HowToContest";
import TopUp from "./TopUp";
import FastImage from "../../../common/FastImage";
import {
  back_arrow,
  coin,
  contest_chat,
  contest_topup,
  share_black,
  share_button,
  WhatsApp,
} from "../../../utils/images";
import Colors from "../../../assets/Color/Colors";
import ContestStatus from "./ContestStatus";
import {globalConfigurableData, globalConst} from "../../../utils/globalConstant";
import {
  buildLinkContest,
  buildLinkContestEvent,
  getLoginRoute,
  openURL,
} from "../../../utils/commonMethods";
import { globalImport } from "../../../common/globalImports";
import { showLoader } from "../../../commonComponents/Loader/loader.actions";
import ShareLinkContest from "./ShareLinkContest";
import { Icon } from '@iconify/react';

const ContestHandling = ({
  contestId,
  chatLink,
  eventId,
  shareLink,
  fantasyData,
}) => {
  const navigation = useNavigation();
  const [isShowErrorPopUp, setIsShowErrorPopup] = React.useState(false);
  const [topUpPopUp, setTopUpPopUp] = React.useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const data = useSelector(({ utilReducer }) => utilReducer.isAppLogin);
  const logedIn = globalImport.isWeb
    ? window.localStorage.getItem("token")
    : data;

  const contestBalanceData = useSelector(
    ({ contestLeaderboardReducer }) =>
      contestLeaderboardReducer?.contestBalanceData
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      contestBalanceData?.errorCode == 422 ||
      contestBalanceData?.errorCode == 402
    ) {
      setIsShowErrorPopup(true);
    }
  }, [contestBalanceData]);

  const onTopUpResponse = (res) => {
    setShowStatus(res?.data);
    dispatch(getContestCoinsBalance(contestId));
    // setTopUpPopUp(false);
  };

  const onTopUpClose = () => {
    setShowStatus(null);
    setTopUpPopUp(false);
  };

  useFocusEffect(
    React.useCallback(() => {
      if (!logedIn) {
        setIsShowErrorPopup(true);
      } else {
        dispatch(getContestCoinsBalance(contestId));
      }
    }, [logedIn])
  );

  const onCallbackHowToContest = () => {
    if (!logedIn) {
      navigation.navigate(getLoginRoute());
      setIsShowErrorPopup(false);
    } else {
      //call join contest
      navigation.push("Fantasy", {
        screen: "contestDetail",
        params: { contestId },
      });
      setIsShowErrorPopup(false);
    }
  };

  const shareMethod = () => {
    dispatch(showLoader());
    const link = buildLinkContest(
      contestId,
      fantasyData?.contest_title,
      shareLink,
      fantasyData?.prize_pool
    );
    //buildLinkContestEvent(contestId, eventId, title, shareLink);
  };

  return (
    <View>
      <View
        style={[
          {
            flex: 1,
            justifyContent: "flex-start",
          },
          styles.aboutContestContainer,
        ]}
      >
        <View style={styles.header}>
          <TouchableOpacity onPress={() => navigation.goBack()}>
            <Icon 
              icon="tabler:arrow-left"
              style={styles.backBtnStyle}
              color={globalConfigurableData.primaryTextColor1}
              width="24"
              height="24"
            />
          </TouchableOpacity>
          
          <TouchableOpacity onPress={() => shareMethod()}>
            <Icon 
              icon="tabler:share-2"
              style={styles.backBtnStyle}
              color={globalConfigurableData.primaryTextColor1}
              width="24"
              height="24"
            />
          </TouchableOpacity>
        </View>
        <View style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
          <View style={{ marginRight: 0 }}>
            <View style={styles.balButton}>
              <FastImage
                style={{ width: 18, height: 18, marginRight: 5 }}
                source={globalConfigurableData.coin()}
              />
              <Text
                style={{
                  ...globalFontStyle.appFontBody,
                  color: Colors.black,
                }}
              >
                {contestBalanceData?.coins}
              </Text>
            </View>
          </View>
          {shareLink ? (
            <View>
              {Platform.OS !== "web" ? (
                <TouchableOpacity
                  onPress={() => shareMethod()}
                  style={{ padding: 5 }}
                >
                  <FastImage
                    style={styles.shareBtnStyle}
                    source={share_black()}
                  />
                </TouchableOpacity>
              ) : (
                <ShareLinkContest
                  contestName={fantasyData?.contest_title}
                  prizePool={fantasyData?.prize_pool}
                  sharaebleLink={shareLink}
                />
              )}
            </View>
          ) : null}
        </View>
      </View>
      <CommonModal
        onModalCallBack={() => {}}
        customModalStyle={[globalStyle.modalView]}
        showModal={isShowErrorPopUp}
      >
        <HowToContest
          isBottomSheet={true}
          isShowCTA={true}
          onCallbackHowToContest={onCallbackHowToContest}
          coinsTobeAdded={contestBalanceData?.coinsTobeAdded}
        />
      </CommonModal>
      {/*<CommonModal*/}
      {/*  onModalCallBack={onTopUpClose}*/}
      {/*  customModalStyle={[globalStyle.modalView, { paddingTop: 0 }]}*/}
      {/*  showModal={topUpPopUp}*/}
      {/*>*/}
      {/*  {showStatus ? (*/}
      {/*    <ContestStatus*/}
      {/*      onDoneClick={onTopUpClose}*/}
      {/*      apiRespnseUiData={showStatus}*/}
      {/*    />*/}
      {/*  ) : (*/}
      {/*    <TopUp*/}
      {/*      onTopUpResponse={onTopUpResponse}*/}
      {/*      contestBalanceData={contestBalanceData}*/}
      {/*      contestId={contestId}*/}
      {/*    />*/}
      {/*  )}*/}
      {/*</CommonModal>*/}
    </View>
  );
};

export default ContestHandling;

const styles = StyleSheet.create({
  aboutContestContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 10,
    alignItems: "center",
    borderBottomColor: "rgba(0, 0, 0, 0.5)",
    //borderWidth: 0.2,
    shadowColor: "rgba(0, 0, 0, 0.15)",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    top: 0,
    position: globalImport?.isWeb ? "sticky" : "relative",
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
    elevation: 3,
    zIndex: 1000,
  },
  shareBtnStyle: {
    width: 30,
    height: 30,
  },
  backBtnStyle: {
    width: 24,
    height: 24,
  },
  topUpBtn: {
    flex: 0,
    backgroundColor: "#F5F5F5",
    borderColor: Colors.black,
    paddingHorizontal: 10,
    borderRadius: 5,
    borderWidth: 0.5,
    paddingVertical: 6,
    flexDirection: "row",
    alignItems: "center",
  },
  balButton: {
    borderColor: Colors.black,
    paddingHorizontal: 10,
    borderRadius: 100,
    borderWidth: 0.75,
    paddingVertical: 6,
    marginRight: 15,
    flexDirection: "row",
    alignItems: "center",
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
});
